import React from 'react';
import PropTypes from 'prop-types';
import WindowCharts from './components/charts/WindowCharts';
import WindowMeasures from './components/measures/WindowMeasures';
import ArchesTransoms from './components/ArchesTransoms';
import LaborMaterial from './components/LaborMaterial';
import Comments from './components/Comments';
import ProjectNeeds from './components/ProjectNeeds';
import HomeDiagram from './components/HomeDiagram';
import ProductTemplate from './components/ProductTemplate';

function WindowsTemplate({
  data,
  onChange,
  permitRequired,
  onPermitRequiredChange,
  onReadStart,
  onReadEnd,
  canViewPriceAdjustment,
}) {
  const {
    measures = { windows: [] },
    arches_transoms_measures = [],
    labors_materials = [],
    comments = '',
    needs = {},
    home_diagram = {},
    product_template = {},
  } = data;

  return (
    <div>
      <h4>Windows Worksheet</h4>
      <WindowCharts />
      <WindowMeasures
        measures={measures.windows}
        onChange={updatedMeasures => onChange(
          { ...data, measures: { ...data.measures, windows: updatedMeasures } },
        )}
      />
      <ArchesTransoms
        arches_transoms_measures={arches_transoms_measures}
        onChange={updatedArchesTransoms => onChange(
          { ...data, arches_transoms_measures: updatedArchesTransoms },
        )}
        openingCount={measures.windows.length}
        openingTypeLabel="window"
      />
      <LaborMaterial
        labors_materials={labors_materials}
        onChange={updatedLaborsMaterials => onChange(
          { ...data, labors_materials: updatedLaborsMaterials },
        )}
        canViewPriceAdjustment={canViewPriceAdjustment}
      />
      <Comments
        comments={comments}
        onChange={updatedComments => onChange(
          { ...data, comments: updatedComments },
        )}
      />
      <ProjectNeeds
        needs={needs}
        onChange={updatedNeeds => onChange({ ...data, needs: updatedNeeds })}
        permitRequired={permitRequired}
        onPermitRequiredChange={onPermitRequiredChange}
      />
      <HomeDiagram
        home_diagram={home_diagram}
        onChange={updatedHomeDiagram => onChange(
          { ...data, home_diagram: updatedHomeDiagram },
        )}
        onReadStart={onReadStart}
        onReadEnd={onReadEnd}
      />
      <ProductTemplate
        product_template={product_template}
        onChange={updatedProductTemplate => onChange(
          { ...data, product_template: updatedProductTemplate },
        )}
        onReadStart={onReadStart}
        onReadEnd={onReadEnd}
      />
    </div>
  );
}

WindowsTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  permitRequired: PropTypes.bool,
  onPermitRequiredChange: PropTypes.func,
  onReadStart: PropTypes.func,
  onReadEnd: PropTypes.func,
  canViewPriceAdjustment: PropTypes.bool,
};

export default WindowsTemplate;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/WindowsTemplate.jsx